/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shy_Clear_Newt_SingInputs */

const en_shy_clear_newt_sing = /** @type {(inputs: Shy_Clear_Newt_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New topics discovered`)
};

const de_shy_clear_newt_sing = /** @type {(inputs: Shy_Clear_Newt_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Themen entdeckt`)
};

/**
* | output |
* | --- |
* | "New topics discovered" |
*
* @param {Shy_Clear_Newt_SingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shy_clear_newt_sing = /** @type {((inputs?: Shy_Clear_Newt_SingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shy_Clear_Newt_SingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shy_clear_newt_sing(inputs)
	return de_shy_clear_newt_sing(inputs)
});